// extracted by mini-css-extract-plugin
module.exports = {"sa-allocation":"selling-agent-allocation_sa-allocation__34Y-2","button":"selling-agent-allocation_button__HfeaW"};